
cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Node,
        follower: cc.Node,
        widthOffset: 0,
        heightOffset: 0,
    },

    onLoad () {
        if (!this.target) {
            return;
        }

        if (!this.follower) {
            return;
        }

        this.target.on(cc.Node.EventType.SIZE_CHANGED, this.onResized, this);

        this.onResized();
    },

    onDestroy () {
        this.target.off(cc.Node.EventType.SIZE_CHANGED, this.onResized, this);
    },

    onResized () {
        this.follower.width = this.target.width + this.widthOffset;
        this.follower.height = this.target.height + this.heightOffset;
    },

});
